import React, { useState } from "react";

// Lightweight YouTube embed: shows a poster + play button, only loads the
// iframe (youtube-nocookie) after the user clicks. Keeps the page fast.
export default function YouTubeFacade({ videoId, title, poster, className = "" }) {
  const [playing, setPlaying] = useState(false);

  return (
    <div
      className={`relative aspect-video overflow-hidden rounded-xl shadow-2xl ring-1 ring-white/10 ${className}`}
    >
      {playing ? (
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          aria-label={`Play video: ${title}`}
          className="group absolute inset-0 h-full w-full text-left"
        >
          <img
            src={poster}
            alt={title}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <span className="absolute inset-0 bg-black/30 transition group-hover:bg-black/15" />
          <span className="absolute left-1/2 top-1/2 flex size-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-brand-pink/90 shadow-lg transition group-hover:scale-110 sm:size-20">
            <svg viewBox="0 0 24 24" fill="white" aria-hidden="true" className="ml-1 size-8 sm:size-9">
              <path d="M8 5v14l11-7z" />
            </svg>
          </span>
        </button>
      )}
    </div>
  );
}
